import { injectable, inject } from 'inversify';
import { Message, Field, Type } from "protobufjs/light";
import { ok, err } from '@xlearn/common'
import { reportNonFatalError } from '@/app/error-handling'
import * as SerializationApi from '@/app/state-serialization/api'
import { QuestionStateSerializer } from '@/app/question/tracking/serialization'

@injectable()
export class QuestionStateProtobufSerializer {

  constructor(
    @inject(QuestionStateSerializer)
    private serializer: QuestionStateSerializer) {
  }
  
  serializeContent(type: string,
                           dataType: 'state' | 'answer',
                           content: { value: unknown } | null) {

    if (content === null) { return ok(undefined) }
    
    const result = this.serializer.serialize(type, dataType, content.value, 'protobuf')
    if (!result.success) {
      this.displaySerializationError(type, dataType, result.error)
      return err(result.error)
    }
    
    return ok(result.value.buffer)
  }

  deserializeContent(type: string,
                             dataType: 'state' | 'answer',
                             input: Uint8Array) {

      if (input.length === 0) { return ok(null) }
      
      const result = this.serializer.deserialize(type, dataType, input, 'protobuf')
      if (!result.success) {
        this.displaySerializationError(type, dataType, result.error)
        return err(result.error)
      }

      return ok({ value: result.value })

  }

  private displaySerializationError(type: string, dataType: string,
                                    error: SerializationApi.TypedStateSerializeError |
        SerializationApi.TypedStateDeserializeError) {

    const typeTag = type + '-' + dataType
    switch (error.code) {
      case 'serializer-not-found':
        const name = error.details
        reportNonFatalError(`question state 'protobuf' serializer not found with name '${JSON.stringify(name)}', ` +
              `question state won't be included`)
        break
      case 'serialize-error':
        reportNonFatalError(`question state 'protobuf' serialization error for type '${typeTag}', ` +
              `question's state won't be included in saved data`, error.details)
      case 'deserialize-error':
        reportNonFatalError(`question state 'protobuf' deserialization error for type '${typeTag}', ` +
              `question's state won't be included in loaded data`, error.details)
        break
    }
  }
}
